<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Selección</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/subscription" color="primary"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="resetClicked()" fill="clear" color="primary" *ngIf="lockedZone.go || lockedZone.return">
        Borrar
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="mySubscription">
  <div class="ion-padding">
    <h4>
      Suscripción:
      <strong *ngIf="mySubscription">{{mySubscription.fullname}}</strong>
      <br />
      <strong *ngIf=" mySubscription && mySubscription.zone_name">{{mySubscription.zone_name}}</strong>
      <br />
      Escoger rutas y horarios
    </h4>
  </div>
  <div *ngIf="mySubscription">
    <ion-card *ngFor="let item of subscription">
      <ion-row>
        <ion-col>
          <h5>{{item.day}}</h5>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="mySubscription && ( mySubscription.type==='complete' || mySubscription.type==='go')">
        <ion-col>
          <strong><u>LLEGADA</u></strong>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="mySubscription && ( mySubscription.type==='complete' || mySubscription.type==='go')">
        <ion-col>
          <strong>Ruta y parada:</strong>
          <p *ngIf="item.go.stop" hidden>Ruta {{item.go.stop.route_id}}</p>
          <p *ngIf="item.go.stop">{{item.go.stop.name}}</p>
        </ion-col>
        <ion-col size="3" class="ion-text-center">
          <strong>Hora:</strong>
          <p>{{item.go.departure_time}}</p>
        </ion-col>
        <ion-col size="2" class="ion-text-center">
          <ion-button size="small" fill="clear" (click)="selectStop(item, 'go')">
            <ion-icon slot="icon-only" name="create"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="mySubscription && ( mySubscription.type==='complete' || mySubscription.type==='return')">
        <ion-col>
          <strong><u>SALIDA</u></strong>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="mySubscription && ( mySubscription.type==='complete' || mySubscription.type==='return')">
        <ion-col>
          <strong>Ruta y parada:</strong>
          <p *ngIf="item.return.stop" hidden>Ruta {{item.return.stop.route_id}}</p>
          <p *ngIf="item.return.stop">{{item.return.stop.name}}</p>
        </ion-col>
        <ion-col size="3" class="ion-text-center">
          <strong>Hora:</strong>
          <p>{{item.return.departure_time}}</p>
        </ion-col>
        <ion-col size="2" class="ion-text-center">
          <ion-button size="small" fill="clear" (click)="selectStop(item, 'return')">
            <ion-icon slot="icon-only" name="create"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-card>
  </div>
  <div class="ion-padding">
    <ion-button
      shape="round"
      fill="solid"
      color="primary"
      expand="block"
      [disabled]="!validForm"
      (click)="save()"
      *ngIf="mySubscription && mySubscription.status"
    >
      Guardar
    </ion-button>
  </div>
</ion-content>

<ion-footer class="ion-padding" *ngIf="mySubscription && mySubscription.status === 0">
  <ion-button
    shape="round"
    fill="outline"
    color="primary"
    expand="block"
    [disabled]="!validForm || (!subscriptionPrice && (!extraSubscription && !isResetSubscription))"
    (click)="goPayment()"
  >
    <div *ngIf="!mySubscription.extra_subscribable && !isResetSubscription">
      Pagar
      <span *ngIf="subscriptionPrice">${{subscriptionPrice | number}}</span>
    </div>
    <div *ngIf="extraSubscription || isResetSubscription">Suscribir</div>
  </ion-button>
</ion-footer>
